module.exports = __webpack_public_path__ + "img/C7938D_E0DBE1_D1BBBC_D5CCCB-256px.9f1da177.png";